import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const GetFolderStructureAction = createAsyncThunk("getFolderStructure",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.fileList, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const GetFolderStructureSlice = createSlice({
    name: "getFolderStructure",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false
    },
    reducers: {
        GetFolderStructureReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false
            };
        },
    },
    extraReducers: {
        [GetFolderStructureAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [GetFolderStructureAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [GetFolderStructureAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { GetFolderStructureReset } = GetFolderStructureSlice.actions
export default GetFolderStructureSlice.reducer